module.exports = __webpack_public_path__ + "img/home-service-shuiti.80d571fd.png";